import './our-story.css'
import pic2 from '../../../static/pic2.png';
import pic3 from '../../../static/pic3.png';
const Ourstory =() => {
  return(
    <div class="ourstory">
      <div class="top-con"><div id="TL"><img src={pic2} alt="pic2"/></div><div id="TR"><h3>Who we are</h3><p>Hua Psychology Club is a Registered Student Organization (RSO) at the University of Washington founded by Chinese psychology students.</p>
<p>We aim to raise awareness of mental health issues and educate about basic and interesting theories of psychology.</p></div></div>
      <div class="bot-con"><div id="BL"><h3>What we want to achieve</h3><ul><li> Inform people that psychology relates to everyone's daily life.
</li><li> Mental health issues are not something to avoid or shameful. We encourage people not to be afraid of reaching out for professional help.
</li></ul></div><div id="BR"><img src={pic3} alt="pic3"/></div></div>
    </div>
  )
}

export default Ourstory;
